import { toRefs, computed } from '@vue/composition-api';
import { QueryParam, QuerySchema } from '../types';
import { convertSchemaTreeToMap, isQueryParamComplete } from '../common';

export interface IUseSearchProps {
  readonly schema: QuerySchema;
  readonly query: QueryParam[];
}

export const useSearch = (props: IUseSearchProps) => {
  const { schema, query } = toRefs(props);

  const schemaAsMap = computed(() => convertSchemaTreeToMap(schema.value));
  const activeQueryParam = computed(() => query.value[query.value.length - 1]);

  const isActiveQueryParamComplete = computed(() => {
    return activeQueryParam.value
      ? isQueryParamComplete({ param: activeQueryParam.value, schema: schemaAsMap.value })
      : true;
  });

  return {
    schemaAsMap,
    activeQueryParam,
    isActiveQueryParamComplete,
  };
};
